import React from 'react';
import { useParams } from 'react-router-dom';
import ProjectDetailsModal from './ProjectDetailsModal';

const ProjectDetailsPage = () => {
  const { projectId } = useParams();

  return (
    <ProjectDetailsModal
      viewMode="page"
      isOpen={true}
      project={{ id: projectId }}
    />
  );
};

export default ProjectDetailsPage;
